export default "__VITE_ASSET__DLsmexlc__"